<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <AppToast />
    <AppUpdateModal />
  </div>
</template>

<script setup lang="ts">
import { useUploadSync } from '~/composables/useUploadSync';
useUploadSync();
</script>